import { Host, h } from "@stencil/core";
import { DataLayerService, EventName } from "../../utils/services/datalayer";
import { TrackingObjectBuilder } from "../../utils/services/datalayer/tracking-object-builder";
export class OhIconButton {
    constructor() {
        this.icon = undefined;
        this.iconSize = undefined;
        this.iconSizeMobile = undefined;
        this.ariaLabel = undefined;
        this.parentComponent = undefined;
    }
    handleEvent(e) {
        this.ohIconButtonClick.emit(e);
        if (this.parentComponent) {
            DataLayerService.pushEvent(EventName.BUTTON, new TrackingObjectBuilder().forButtonClick({ clickText: this.icon, parentComponent: this.parentComponent }));
        }
    }
    render() {
        const label = this.ariaLabel ?? 'button-icon';
        return (h(Host, { key: '812fb530214f01899c5b54e4c96a34ac54ea117c' }, h("button", { key: '222036802bccc0ec20d98252ce33ccaff1c1690a', onClick: (e) => this.handleEvent(e), title: label, "aria-label": label }, h("oh-icon", { key: '6df8f3f39e89a32f093278fe0327045d97aa550e', name: this.icon, size: this.iconSize, ...(this.iconSizeMobile && { sizeMobile: this.iconSizeMobile }) }))));
    }
    static get is() { return "oh-icon-button"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["oh-icon-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["oh-icon-button.css"]
        };
    }
    static get properties() {
        return {
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "icon",
                "reflect": false
            },
            "iconSize": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "icon-size",
                "reflect": false
            },
            "iconSizeMobile": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "icon-size-mobile",
                "reflect": false
            },
            "ariaLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "aria-label",
                "reflect": false
            },
            "parentComponent": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "parent-component",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "ohIconButtonClick",
                "name": "ohIconButtonClick",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=oh-icon-button.js.map
